import { Organization } from "types";
import { getApi } from "./util/getApi";
const fetchURL = process.env.REACT_APP_API_URL + "/organization";

const api = getApi(fetchURL);
const baseApi = getApi(process.env.REACT_APP_API_URL);

export const createOrganization = (data: Organization) =>
  api.post("/createProfile", data).then((r) => r.data);

export const submitOrganizationDocuments = async (
  orgCreationToken: string,
  fileFor: string,
  fileData: any
) => {
  const formData = new FormData();
  formData.append(fileFor, fileData);
  formData.append("org_creation_token", orgCreationToken);
  formData.append("file_for", fileFor);
  const res = await api.post("/verificationUpload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res;
};

export const getOrganizationsByUserId = () =>
  api.post<OrgBubble[]>("/getOrganizationsByUserId").then((r) => r);

export const retrieveEventAttendees = async (id: number) => {
  const res = await baseApi.post(`activity/retrieveUserInfo`, { id });
  return res.data;
};

export const getCities = () =>
  api.get<{ id: number; name: string }[]>("/getCities").then((r) => r.data);
